import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  RouterProvider,
  createBrowserRouter,
  redirect,
} from "react-router-dom";
import Members from "./pages/members/Members";
import { configure } from "axios-hooks";
import axios from "./api/axios-conf";
import Member from "./pages/members/Member";
import MemberStats from "./pages/members/MemberStats";
import Auth from "./pages/auth/Auth";
import Login from "./pages/auth/Login";
import SignUp from "./pages/auth/SignUp";
import SignUpConfirm from "./pages/auth/SignUpConfirm";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ForgotPasswordConfirm from "./pages/auth/ForgotPasswordConfirm";
import Account from "./pages/account/Account";
import AccountSubscription, {
  AccountIntialSubscriptionView,
} from "./pages/account/AccountSubscription";
import AccountSettings from "./pages/account/AccountSettings";
import MemberSettings from "./pages/members/MemberSettings";
import AccountInfo from "./pages/account/AccountInfo";
import LoginMFA from "./pages/auth/LoginMFA";
import RecoverMFA from "./pages/auth/RecoverMFA";
import Businesses from "./pages/businesses/Businesses";
import Business from "./pages/businesses/Business";
import BusinessSettings from "./pages/businesses/BusinessSettings";
import BusinessUsers from "./pages/businesses/users/BusinessUsers";
import Organization from "./pages/organization/Organization";
import Classrooms from "./pages/classrooms/Classrooms";
import Classroom from "./pages/classrooms/Classroom";
import ClassroomStudents from "./pages/classrooms/ClassroomStudents";
import ClassroomSettings from "./pages/classrooms/ClassroomSettings";
import ClassroomInstructors from "./pages/classrooms/ClassroomInstructors";
import Instructors from "./pages/instructors/Instructors";
import Instructor from "./pages/instructors/Instructor";
import InstructorStats from "./pages/instructors/InstructorStats";
import InstructorSettings from "./pages/instructors/InstructorSettings";
import InstructorStudents from "./pages/instructors/InstructorStudents";
import InstructorClassrooms from "./pages/instructors/InstructorClassrooms";
import ImportJobs from "./pages/import-jobs/ImportJobs";
import ImportJob from "./pages/import-jobs/ImportJob";
import ForceChangePassword from "./pages/auth/ForceChangePassword";
import Assignments from "./pages/assignments/Assignments";
import Assignment from "./pages/assignments/Assignment";
import AssignmentStudents from "./pages/assignments/AssignmentStudents";
import AssignmentSettings from "./pages/assignments/AssignmentSettings";
import AssignmentContentManager from "./pages/assignments/AssigmentContentManager";
import AssigmentStats from "./pages/assignments/AssigmentStats";
import ClassroomAssignments from "./pages/classrooms/ClassroomAssigments";

configure({ axios, cache: false });

export const routes = [
  {
    path: "auth",
    loader: async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_HOST_URI}/auth/user`,
          { credentials: "include" }
        );
        const user = await response.json();

        if (response.status === 401) {
          return "";
        }
        if (user["cognito:groups"].includes("BUSINESS_GLOBAL_ADMIN")) {
          return redirect("/organizations");
        }
        if (user["cognito:groups"].includes("BUSINESS_ADMIN")) {
          return redirect("/users");
        }
        if (user["cognito:groups"].includes("BUSINESS_INSTRUCTOR")) {
          return redirect("/students");
        }
      } catch (error) {
        console.log(error);
      }
    },
    element: <Auth></Auth>,
    children: [
      {
        path: "login",
        element: <Login></Login>,
      },
      {
        path: "forceChangePassword",
        element: <ForceChangePassword></ForceChangePassword>,
      },
      {
        path: "login/mfa",
        element: <LoginMFA />,
      },
      {
        path: "mfa/recover",
        element: <RecoverMFA />,
      },
      {
        path: "signup",
        children: [
          { path: "", element: <SignUp></SignUp> },
          { path: "confirm", element: <SignUpConfirm></SignUpConfirm> },
        ],
      },
      {
        path: "forgot-password",

        children: [
          {
            path: "",
            element: <ForgotPassword></ForgotPassword>,
          },
          {
            path: "confirm",
            element: <ForgotPasswordConfirm></ForgotPasswordConfirm>,
          },
        ],
      },
    ],
  },
  {
    path: "subscription/init",
    element: <AccountIntialSubscriptionView></AccountIntialSubscriptionView>,
  },
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "",
        loader: async () => {
          const response = await fetch(
            `${process.env.REACT_APP_HOST_URI}/auth/user`,
            { credentials: "include" }
          );

          const user = await response.json();

          if (response.status === 401) {
            return "";
          }

          if (user["cognito:groups"].includes("BUSINESS_ADMIN")) {
            return redirect("/users");
          }

          if (user["cognito:groups"].includes("BUSINESS_GLOBAL_ADMIN")) {
            return redirect("/organizations");
          }

          if (user["cognito:groups"].includes("BUSINESS_INSTRUCTOR")) {
            return redirect("/students");
          }

          return redirect("/");
        },
      },

      // {
      //   path: "subscription",
      //   element: <Subscription></Subscription>,
      // },
      {
        path: "users",
        children: [
          {
            path: "",
            element: (
              <BusinessUsers
                filter={{ roles: ["BUSINESS_ADMIN", "BUSINESS_INSTRUCTOR"] }}
              ></BusinessUsers>
            ),
          },
        ],
      },

      {
        path: "classrooms",
        children: [
          {
            path: "",
            element: <Classrooms />,
          },
          {
            path: ":classroomId",
            element: <Classroom></Classroom>,
            children: [
              {
                path: "students",
                element: <ClassroomStudents></ClassroomStudents>,
              },
              {
                path: "instructors",
                element: <ClassroomInstructors />,
              },
              {
                path: "settings",
                element: <ClassroomSettings></ClassroomSettings>,
              },
              {
                path: "assigments",
               
                element: <ClassroomAssignments></ClassroomAssignments>,
              },
            ],
          },
        ],
      },

      {
        path: "students",
        children: [
          {
            path: "",
            element: <Members />,
          },
          {
            path: ":memberId",
            element: <Member></Member>,
            children: [
              {
                path: "stats",
                element: <MemberStats></MemberStats>,
              },
              {
                path: "settings",
                element: <MemberSettings></MemberSettings>,
              },
            ],
          },
        ],
      },

      {
        path: "instructors",
        children: [
          {
            path: "",
            element: <Instructors />,
          },
          {
            path: ":instructorId",
            element: <Instructor></Instructor>,
            children: [
              {
                path: "classrooms",
                element: <InstructorClassrooms />,
              },
              {
                path: "students",
                element: <InstructorStudents />,
              },
              {
                path: "settings",
                element: <InstructorSettings></InstructorSettings>,
              },
            ],
          },
        ],
      },

      {
        path: "import-jobs",
        children: [
          {
            path: "",
            element: <ImportJobs></ImportJobs>,
          },
          {
            path: ":jobId",
            element: <ImportJob></ImportJob>,
          },
        ],
      },

      {
        path: "assignments",
        children: [
          {
            path: "",
            element: <Assignments></Assignments>,
          },
          {
            path: ":assignmentId",
            element: <Assignment></Assignment>,
            children: [
              {
                path: "courses",
                element: (
                  <AssignmentContentManager
                    type="courses"
                    contentKey="courses"
                    label="Course"
                  />
                ),
              },
              {
                path: "labs",
                element: (
                  <AssignmentContentManager
                    type="labs"
                    contentKey="labs"
                    label="Lab"
                  />
                ),
              },
              {
                path: "stats",
                element: <AssigmentStats />,
              },

              {
                path: "settings",
                element: <AssignmentSettings />,
              },
            ],
          },
        ],
      },

      {
        path: "organization",
        element: <Organization />,
      },
      {
        path: "organizations",
        children: [
          {
            path: "",
            element: <Businesses></Businesses>,
          },
          {
            path: ":businessId",
            element: <Business></Business>,
            children: [
              {
                path: "users",
                children: [
                  {
                    path: "",
                    element: <BusinessUsers></BusinessUsers>,
                  },
                ],
              },
              {
                path: "settings",
                element: <BusinessSettings></BusinessSettings>,
              },
            ],
          },
        ],
      },
      {
        path: "account",
        element: <Account></Account>,
        children: [
          {
            path: "subscription",
            element: <AccountSubscription></AccountSubscription>,
          },
          {
            path: "info",
            element: <AccountInfo />,
          },
          {
            path: "settings",
            element: <AccountSettings />,
          },
        ],
      },
    ],
  },
];

const router = createBrowserRouter(routes);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
  <RouterProvider router={router} />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
